import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { isSceneGroupApiUrl } from './scene-group-api.config';

@Injectable()
export class SceneGroupAuthInterceptor implements HttpInterceptor {
  constructor(private readonly firebaseAuth: FirebaseAuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!isSceneGroupApiUrl(req.url)) {
      return next.handle(req);
    }

    // getUserToken() waits for the auth user (same primitive cards.service.ts
    // uses) instead of firing admin requests unauthenticated during the auth
    // race. withCredentials mirrors cards.service.ts getRequestOptions().
    return from(this.firebaseAuth.getUserToken()).pipe(
      switchMap(token =>
        next.handle(req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        })),
      ),
    );
  }
}
